<div
  class="course-card bg-white rounded-lg overflow-hidden border border-gray-200 shadow-md h-full flex flex-col"
>
  <div class="course-image-container relative">
    <div class="course-badge-container absolute top-2 right-2 z-10 flex flex-row-reverse gap-2">
      <ng-container *ngIf="course?.is_test_published">
        <span class="badge bg-blue-500 text-white px-2 py-1 rounded text-xs font-bold uppercase">
          Test Published
        </span>
      </ng-container>
      <ng-container *ngIf="isExpiringSoon(course?.expired_at)">
        <span class="badge bg-red-500 text-white px-2 py-1 rounded text-xs font-bold uppercase">
          Expiring Soon!
        </span>
      </ng-container>
      <ng-container *ngIf="is_myCourse && isExpired()">
        <span class="badge bg-red-500 text-white px-2 py-1 rounded text-xs font-bold uppercase">
          Expired
        </span>
      </ng-container>
      <ng-container *ngIf="course?.participations?.length">
        <span
          class="badge bg-green-500 text-white px-2 py-1 rounded text-xs font-bold uppercase whitespace-nowrap"
        >
          {{ course?.participations?.[0]?.progress === 100 ? 'Completed' : 'Enrolled' }}
        </span>
      </ng-container>
    </div>
    <a [routerLink]="['/courses', course?.uuid]">
      <div class="aspect-w-16 aspect-h-9">
        <img
          [src]="course?.thumb_path || 'assets/images/no-image.jpg'"
          [alt]="course?.title"
          class="w-full h-full object-cover border-b border-gray-200"
          loading="lazy"
        />
      </div>
    </a>
    <ng-container *ngIf="course?.participations?.length">
      <div class="progress h-1 bg-gray-200">
        <div
          class="progress-bar bg-green-500 h-1.5"
          role="progressbar"
          [style.width.%]="
            course?.participations?.[0]?.progress === 0 ? 5 : course?.participations?.[0]?.progress
          "
          [attr.aria-valuenow]="
            course?.participations?.[0]?.progress === 0 ? 5 : course?.participations?.[0]?.progress
          "
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
    </ng-container>
  </div>

  <div class="course-detail-container p-4 flex-grow">
    <div class="course-detail-item title mb-3">
      <h3 class="text-lg font-semibold leading-tight">
        <a [routerLink]="['/courses', course?.uuid]" class="text-gray-800 hover:text-primary-600">
          {{ course?.title }}
        </a>
      </h3>
    </div>

    <div class="space-y-2">
      <div class="text-sm text-gray-600 flex items-start">
        <svg
          class="h-4 w-4 text-gray-400 mr-1.5 mt-0.5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <span>
          <span class="font-medium">Credit Hours:</span> {{ course?.completion_time }}
          {{ (course?.completion_time ?? 0) > 1 ? 'hours' : 'hour' }}
        </span>
      </div>

      <div class="text-sm text-gray-600 flex items-start">
        <svg
          class="h-4 w-4 text-gray-400 mr-1.5 mt-0.5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
        <span>
          <span class="font-medium">Available:</span>
          {{ formatAvailability(course?.released_at, course?.expired_at) }}
        </span>
      </div>

      <div class="text-sm text-gray-500 line-clamp-2 flex items-start">
        <svg
          class="h-4 w-4 text-gray-400 mr-1.5 mt-0.5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <span>
          <span class="font-medium">Credit Offered: {{ course?.courseCreditTypes }}</span>
        </span>
      </div>
      <ng-container *ngIf="is_myCourse">
        <div class="text-sm text-gray-600 flex items-start">
          <svg
            class="h-4 w-4 text-gray-400 mr-1.5 mt-0.5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          <span>
            <span class="font-medium">Date Enrolled:</span>
            {{ formatDate(course?.participations?.[0]?.created_at || '') }}
          </span>
        </div>

        <div class="text-sm text-gray-600 flex items-start">
          <svg
            class="h-4 w-4 text-gray-400 mr-1.5 mt-0.5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M16 7a4 4 0 00-8 0v1H5a2 2 0 00-2 2v2a2 2 0 002 2h14a2 2 0 002-2v-2a2 2 0 00-2-2h-3V7z"
            />
          </svg>
          <span>
            <span class="font-medium">Enrolled As:</span>
            {{ course?.participations?.[0]?.participant_type?.label || 'N/A' }}
          </span>
        </div>

        <div class="text-sm text-gray-600 flex items-start">
          <svg
            class="h-4 w-4 text-gray-400 mr-1.5 mt-0.5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7"
            />
          </svg>
          <span>
            <span class="font-medium">Completed At:</span>
            {{ formatDate(course?.participations?.[0]?.completed_at || '') }}
          </span>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="course-footer-container p-2 bg-gray-50 border-t" *ngIf="shouldShowButton()">
    <div class="course-detail-item access-button flex space-x-1">
      <ng-container *ngIf="(course?.participations?.length ?? 0) > 0">
        <button
          *ngIf="
            course?.participations?.[0]?.progress !== 100 &&
            course?.participations?.[0]?.progress !== null
          "
          (click)="startCourse(course?.uuid ?? '')"
          class="font-semibold btn bg-green-500 hover:bg-green-600 text-white px-1 py-2 rounded transition-colors text-sm flex-1 text-center whitespace-nowrap min-w-[120px]"
        >
          Continue Course
        </button>
        <a
          *ngIf="course?.participations?.[0]?.progress === 100"
          [routerLink]="'/my-account/certificates'"
          class="font-semibold btn bg-green-500 hover:bg-green-600 text-white px-1 py-2 rounded transition-colors text-sm flex-1 text-center whitespace-nowrap min-w-[120px] flex justify-center items-center"
          ><svg
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="h-4 w-4 mr-1"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3"
            />
          </svg>
          Certificate</a
        >
        <a
          [routerLink]="['/courses', course?.uuid]"
          class="font-semibold btn bg-primary-500 hover:bg-primary-600 text-white px-1 py-2 rounded transition-colors text-sm flex-1 text-center whitespace-nowrap min-w-[120px]"
        >
          Course Details
        </a>
      </ng-container>
      <a
        *ngIf="(course?.participations?.length ?? 0) === 0"
        [routerLink]="['/courses', course?.uuid]"
        class="font-semibold btn text-white px-1 py-2 rounded bg-primary-500 hover:bg-primary-600 transition-colors text-sm flex-1 text-center whitespace-nowrap min-w-[120px]"
      >
        Course Details
      </a>
    </div>
  </div>
</div>
